import { Button, Column, Icon, Media, Row, Spacer, Text } from "@bunnix/components";
import Bunnix, { Show, useMemo } from "@bunnix/core";
import { formatRelativeDate } from "../utils/relative-date.mjs";

const { a } = Bunnix;

export default function CompactNewsCard(props = {}) {
  const {
    title, snippet, source, publishedAt, image, url,
    smallContents = false
  } = props.get ? props.get() : props;

  const showImage = useMemo([image],
    (i) => i
  );
  const showSnippet = useMemo([snippet, image], (d, i) =>
    d ? (!i ?? false) : false,
  );

  const RenderImage = () => (
    Show(
      showImage,
      Column(
        { width: `${smallContents ? "max(250px, 33vw)" : "max(450px, 50vw)"}`, overflow: "hidden" },
        Media({ content: "cover", src: image })
      )
    )
  )

  const RenderTitle = () => Text(
    {
      fontSize: "large", fontAdjust: `${ smallContents ? "small-title" : "title" }`, fontWeight: 600,
    }, title
  )

  const RenderSnippet = () => (
    Show(
      showSnippet,
      Text({ dimmed: true }, snippet)
    )
  )

  const RenderSourceRow = () => (
    Row(
      { alignItems: "end" },
      Text({ fontSize: "small", fontWeight: 600 }, source),
      Spacer(),
      Text({ fontSize: "small", fontWeight: 600, dimmed: true }, formatRelativeDate(publishedAt))
    )
  )

  const RenderBottomRow = () => (
    Row(
      Spacer(),
      Icon({ name: "arrow_up_right", size: 20 })
    )
  )

  return (
    Column(
      {
        padding: "regular", overflow: "hidden",
        width: "100%", height: "100%",
        fontColor: "white",
        selectable: "none",
        gap: 12
      },
      RenderSourceRow(),
      a(
        { href: url, target: "_blank", rel: "noopener noreferrer", fontColor: "white", },
        Row(
          { alignItems: "start", gap: 12 },
          Column(
            { gap: 12 },
            RenderTitle(),
            RenderSnippet(),
          ),
          RenderImage()
        ),
      ),
      Spacer(),
      RenderBottomRow()
    )
  )
}
